import getConfig from 'next/config';
import {
  WEB_SCHEMA,
  WEBPAGE_SCHEMA_TYPE,
} from '../../../constants/stocks/componentStaticData';
import { Meta } from '../../../layout/Meta';
import { b2cData } from '../../cms/layout/components/header';
import { ClearInNavbar } from '../../Navbar/ClearNavbar';
import { ALL_CITIES, GOLD_CITY, METALS, SILVER_CITY } from '../common/types';
import { capitalized } from '../common/utils';
import GoldCityHomepage from '../gold-city-page';
import { StocksLayout } from './stocks-layout';
import { getFullDateWithOrdinals } from '../../Utils/UtilFunctions';

interface GOLD_RATE_PROPS {
  city: string;
  date?: string;
  data: GOLD_CITY | SILVER_CITY;
  cities: ALL_CITIES;
  graphData: number[][];
  top_cta: string;
}
const { publicRuntimeConfig } = getConfig();

const GoldPageLayout = ({
  city,
  data,
  cities,
  graphData,
  top_cta,
}: GOLD_RATE_PROPS): JSX.Element => {
  const capitalizedCityName = capitalized(city);
  const todayDate = getFullDateWithOrdinals(new Date().toDateString());
  const seoDetails: WEBPAGE_SCHEMA_TYPE = {
    title: `Gold Rate in ${capitalizedCityName} Today (${todayDate}), 22 & 24 Carat Gold Price in ${capitalizedCityName} - ClearTax`,
    metaDesc: `Today Gold Rate in ${capitalizedCityName} (${todayDate}): Get 22 & 24 Carat/Karat gold price in ${capitalizedCityName} for 1 gram, 8 gram and 10 gram. Check out last 10 days gold price trend and movement in ${capitalizedCityName} at ClearTax.`,
    url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/${METALS.GOLD}-rate-${city}`,
  };

  return (
    <StocksLayout
      slider={false}
      meta={
        <Meta
          title={seoDetails.title}
          description={seoDetails.metaDesc}
          canonical={seoDetails.url}
        />
      }
    >
      <ClearInNavbar data={b2cData} />

      <GoldCityHomepage
        goldData={data as GOLD_CITY}
        cityData={cities}
        city={{ type: 'major', name: city }}
        graphData={graphData}
        metal={METALS.GOLD}
        top_cta={top_cta}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(WEB_SCHEMA(seoDetails)),
        }}
      ></script>
    </StocksLayout>
  );
};
export default GoldPageLayout;
